export default function getUserInitials(user) {
	const firstNameInitial = user.firstName?.trim()[0] || "";
	const lastNameInitial = user.lastName?.trim().split(" ").pop()[0] || "";

	return firstNameInitial + lastNameInitial;
}
